<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="isAddPopup ? 'IP 검색 대역 추가' : 'IP 검색 대역 수정'" width="600px" @close="close()">
    <div slot="content">
      <el-form :model="formData" :rules="formRules" ref="modelingForm">
        <el-row>
          <el-form-item prop="startIpaddress" label="시작 IP 주소">
            <el-input v-model="formData.startIpaddress" placeholder="입력해주세요."></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="endIpaddress" label="종료 IP 주소">
            <el-input v-model="formData.endIpaddress" placeholder="입력해주세요."></el-input>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" :disabled="saveButtonDisabled" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, isEqual, cloneDeep } from 'lodash';
import { validateIpv4, validateIpv6 } from '@/utils/string';
import msgUtil from '@/utils/message';
import deviceRegistrationAmsAPI from '@/api/settings/common/device-registration-ams';

export default {
  name: 'WIpScanRangeSettingPopup',
  props: {
    selectedRange: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        startIpaddress: '',
        endIpaddress: '',
      },
      formRules: {
        startIpaddress: {
          required: true,
          trigger: 'blur',
          validator: this.validateStartIpaddress,
        },
        endIpaddress: {
          required: true,
          trigger: 'blur',
          validator: this.validateEndIpaddress,
        },
      },
    };
  },
  computed: {
    isAddPopup() {
      return isNil(this.selectedRange);
    },
    saveButtonDisabled() {
      return !this.isAddPopup && isEqual(this.formData, this.selectedRange);
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      if (!isNil(this.selectedRange)) {
        this.formData = cloneDeep(this.selectedRange);
      }
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.$refs.modelingForm.resetFields();
      this.formData = {
        startIpaddress: '',
        endIpaddress: '',
      };
    },
    /**
     * 시작 IP 유효성 검사
     * @author jeee12
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validateStartIpaddress(rule, value, callback) {
      const endIpaddress = this.formData.endIpaddress;
      const endIpaddressStr = endIpaddress.split('.');
      if (isNil(value) || value === '') {
        callback(new Error('값을 입력해주세요'));
      } else if (!validateIpv4(value) && !validateIpv6(value)) {
        callback(new Error('올바른 IPv4 혹은 IPv6 주소형식을 입력해주세요'));
      } else if (endIpaddress !== '' && ((endIpaddressStr[0] !== value.split('.')[0]) || (endIpaddressStr[1] !== value.split('.')[1]) || (endIpaddressStr[2] !== value.split('.')[2]))) {
        callback(new Error('시작 IP 형식을 확인해주세요'));
      } else if (Number(value.split('.')[3]) > Number(endIpaddressStr[3])) {
        callback(new Error('시작 IP 형식을 확인해주세요'));
      } else if (value.split('.')[3] === '0') {
        callback(new Error('시작 IP 형식을 확인해주세요'));
      }
      callback();
    },
    /**
     * 종료 IP 유효성 검사
     * @author jeee12
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validateEndIpaddress(rule, value, callback) {
      const startIpaddress = this.formData.startIpaddress;
      const startIpaddressStr = startIpaddress.split('.');
      if (isNil(value) || value === '') {
        callback(new Error('값을 입력해주세요'));
      } else if (!validateIpv4(value) && !validateIpv6(value)) {
        callback(new Error('올바른 IPv4 혹은 IPv6 주소형식을 입력해주세요'));
      } else if (startIpaddress !== '' && ((startIpaddressStr[0] !== value.split('.')[0]) || (startIpaddressStr[1] !== value.split('.')[1]) || (startIpaddressStr[2] !== value.split('.')[2]))) {
        callback(new Error('종료 IP 형식을 확인해주세요'));
      } else if (Number(startIpaddressStr[3]) > Number(value.split('.')[3])) {
        callback(new Error('종료 IP 형식을 확인해주세요'));
      } else if (value.split('.')[3] === '255') {
        callback(new Error('종료 IP 형식을 확인해주세요'));
      }
      callback();
    },
    onSaveButton() {
      this.$refs.modelingForm.validate((valid) => {
        if (valid) {
          deviceRegistrationAmsAPI.insertAmsModelingRange(this.formData).then((response) => {
            const target = '자동화 모델링 범위';
            const action = this.isAddPopup ? msgUtil.action.ADD : msgUtil.action.MODIFY;
            if (response.data.success) {
              this.close();
              this.$emit('re-load');
            }
            this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
          });
        }
      });
    },
    loadData() {},
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Server/popup/IpScanRangeSettingPopup.vue